import { SearchOutlined } from '@ant-design/icons';
import { AutoComplete } from 'antd';
import React, { useState } from 'react';

interface ISearch {
  value?: any;
  options?: any;
  onSelect?: any;
  onSearch?: any;
  onChange?: any;
}

const AutoCompleteImport: React.FC<ISearch> = ({
  value,
  options,
  onSelect,
  onSearch,
  onChange
}: ISearch) => {
  return (
    <>
      <AutoComplete
        value={value}
        options={options}
        onSelect={onSelect}
        onSearch={onSearch}
        onChange={onChange}
        placeholder="검색"
      ></AutoComplete>
      <SearchOutlined
        id="search-icon"
        style={{ position: 'relative', right: '50px' }}
      />
    </>
  );
};

export default AutoCompleteImport;
